import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { preloadPrerenderedRoute } from "./prerenderPreload";
import "./styles.css";

// Automatically reload page if chunk hash mismatch occurs after a new deployment
window.addEventListener("vite:preloadError", () => {
  const lastReload = sessionStorage.getItem("last_chunk_reload");
  const now = Date.now();
  if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
    sessionStorage.setItem("last_chunk_reload", String(now));
    window.location.reload();
  }
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Pages prerendered at build time (see src/entry-prerender.jsx) ship full HTML in
// #root and are hydrated; every other page is rendered on the client as before.
if (container.hasAttribute("data-prerendered")) {
  // index.html keeps a prerendered root hidden until the stylesheet's onload adds
  // css-ready; reveal anyway if that never happens (slow or blocked CSS).
  window.setTimeout(() => document.documentElement.classList.add("css-ready"), 3000);
  // The server HTML stays on screen while route data (e.g. a blog article body) loads,
  // so the first client render matches it.
  preloadPrerenderedRoute(window.location.pathname)
    .catch(() => {})
    .then(() => ReactDOM.hydrateRoot(container, tree));
} else {
  // The Go SEO shell (/kodepos*) ships a hidden server body for crawlers without JS.
  // createRoot replaces it anyway, so drop it now and unhide #root: the app shell and
  // Suspense fallback show right away instead of staying hidden until the page chunk
  // mounts, and the unstyled server body never paints. seo-shell-data sits outside
  // #root and is untouched.
  if (container.hasAttribute("data-server-body")) {
    container.replaceChildren();
    container.removeAttribute("data-server-body");
  }
  ReactDOM.createRoot(container).render(tree);
}
